webpackJsonp([114276838955818,60335399758886],{

/***/ 202:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(477);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(202);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 620:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  & {\n    ', '\n  }\n  a {\n    ', '\n    &:last-child { margin-right: 0; }\n    \n    color: inherit;\n    &:hover {\n      color: ', ';\n    }\n  }\n'], ['\n  & {\n    ', '\n  }\n  a {\n    ', '\n    &:last-child { margin-right: 0; }\n    \n    color: inherit;\n    &:hover {\n      color: ', ';\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(19);
	
	var _siteConfig = __webpack_require__(33);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.textAlign && 'text-align: ' + props.textAlign + ';';
	}, function (props) {
	  return props.relaxed && 'margin-right: 1em;';
	}, function (props) {
	  return props.theme.colors.highlight;
	});
	
	var SocialIconLinks = function SocialIconLinks(_ref) {
	  var size = _ref.size,
	      rest = _objectWithoutProperties(_ref, ['size']);
	
	  return _react2.default.createElement(
	    Wrapper,
	    rest,
	    _react2.default.createElement(
	      'a',
	      { href: '//github.com/' + _siteConfig2.default.githubHandle, target: '_blank' },
	      _react2.default.createElement(_semanticUiReact.Icon, { size: size, name: 'github' })
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: '//twitter.com/' + _siteConfig2.default.twitterHandle, target: '_blank' },
	      _react2.default.createElement(_semanticUiReact.Icon, { size: size, name: 'twitter' })
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: '//linkedin.com/in/' + _siteConfig2.default.linkedinHandle, target: '_blank' },
	      _react2.default.createElement(_semanticUiReact.Icon, { size: size, name: 'linkedin' })
	    )
	  );
	};
	
	SocialIconLinks.propTypes = {
	  size: _propTypes2.default.string,
	  relaxed: _propTypes2.default.bool
	};
	
	SocialIconLinks.defaultProps = {
	  size: 'large',
	  relaxed: false
	};
	
	exports.default = SocialIconLinks;
	module.exports = exports['default'];

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  opacity: 0;\n  max-width: 100px;\n'], ['\n  opacity: 0;\n  max-width: 100px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  .ui.header {\n    margin-bottom: 0;\n  }\n  opacity: 0.5;\n'], ['\n  .ui.header {\n    margin-bottom: 0;\n  }\n  opacity: 0.5;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _semanticUiReact = __webpack_require__(19);
	
	var _reactSemanticBooster = __webpack_require__(38);
	
	var _SocialIconLinks = __webpack_require__(169);
	
	var _SocialIconLinks2 = _interopRequireDefault(_SocialIconLinks);
	
	var _siteConfig = __webpack_require__(33);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wordmark = _styledComponents2.default.img(_templateObject);
	
	var FooterAbout = _styledComponents2.default.div(_templateObject2);
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    _reactSemanticBooster.Block,
	    { inverted: true, vertical: true, spacer: .3 },
	    _react2.default.createElement(
	      _semanticUiReact.Container,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { inverted: true, stackable: true },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 5 },
	            _react2.default.createElement(
	              FooterAbout,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Header,
	                { as: 'h4', inverted: true },
	                _siteConfig2.default.siteTitle
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _siteConfig2.default.siteDescription
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 6, verticalAlign: 'middle', textAlign: 'center' },
	            _react2.default.createElement(
	              _semanticUiReact.List,
	              { link: true, inverted: true },
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                { as: 'a', href: 'https://www.contentful.com/', rel: 'nofollow', target: '_blank' },
	                _react2.default.createElement(Wordmark, { src: 'https://images.contentful.com/fo9twyrwpveg/7F5pMEOhJ6Y2WukCa2cYws/398e290725ef2d3b3f0f5a73ae8401d6/PoweredByContentful_DarkBackground.svg', alt: 'Powered by Contentful' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 5, floated: 'right', verticalAlign: 'middle' },
	            _react2.default.createElement(_SocialIconLinks2.default, { textAlign: 'right' })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/favicon.6c9cb8e2.ico";

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.menuProps = exports.menu = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n'], ['\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  flex: 1;\n'], ['\n  flex: 1;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(72);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactSemanticBooster = __webpack_require__(38);
	
	var _siteConfig = __webpack_require__(33);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _theme = __webpack_require__(484);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _footer = __webpack_require__(475);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _favicon = __webpack_require__(598);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	__webpack_require__(483);
	
	__webpack_require__(620);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FlexWrapper = _styledComponents2.default.div(_templateObject);
	
	var FlexContent = _styledComponents2.default.div(_templateObject2);
	
	var menu = exports.menu = [// eslint-disable-line import/prefer-default-export
	{
	  position: 'left',
	  content: [{ name: 'Home', to: '/' }]
	}, {
	  position: 'right',
	  content: [{ name: 'About', to: '/about' }, { name: 'Portfolio', to: '/portfolio' }, { name: 'Blog', to: '/blog' }, { name: 'Contact', to: '/contact', button: { primary: true, circular: true } }]
	}];
	
	var menuProps = exports.menuProps = {
	  pointing: true,
	  secondary: true,
	  container: true,
	  spacer: 2
	};
	
	var Template = function Template(_ref) {
	  var children = _ref.children;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        _siteConfig2.default.siteTitle
	      ),
	      _react2.default.createElement('meta', { charSet: 'utf-8' }),
	      _react2.default.createElement('meta', { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0' }),
	      _react2.default.createElement('link', { rel: 'icon', href: _favicon2.default }),
	      _react2.default.createElement('meta', { name: 'description', content: _siteConfig2.default.siteDescription }),
	      _react2.default.createElement('meta', { property: 'og:title', content: _siteConfig2.default.siteTitle }),
	      _react2.default.createElement('meta', { property: 'og:locale', content: 'en_US' }),
	      _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	      _react2.default.createElement('meta', { property: 'og:site_name', content: _siteConfig2.default.siteTitle }),
	      _react2.default.createElement('meta', { property: 'og:url', content: _siteConfig2.default.siteUrl + _siteConfig2.default.pathPrefix })
	    ),
	    _react2.default.createElement(
	      _styledComponents.ThemeProvider,
	      { theme: _theme2.default },
	      _react2.default.createElement(
	        _reactSemanticBooster.SiteNav,
	        { menu: menu, menuProps: menuProps },
	        _react2.default.createElement(
	          FlexWrapper,
	          null,
	          _react2.default.createElement(
	            FlexContent,
	            null,
	            children()
	          ),
	          _react2.default.createElement(_footer2.default, null)
	        )
	      )
	    )
	  );
	};
	
	exports.default = Template;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  ol, ul {\n    list-style: none;\n    padding: 0;\n  }\n  \n  blockquote, q {\n    quotes: none;\n  }\n  \n  blockquote:before,\n  blockquote:after,\n  q:before,\n  q:after {\n    content: \'\';\n    content: none;\n  }\n  \n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n\n  * {\n    box-sizing: border-box;\n  }\n\n  img {\n    display: block;\n  \twidth: 100%;\n  \theight: auto;\n  }\n'], ['\n  ol, ul {\n    list-style: none;\n    padding: 0;\n  }\n  \n  blockquote, q {\n    quotes: none;\n  }\n  \n  blockquote:before,\n  blockquote:after,\n  q:before,\n  q:after {\n    content: \'\';\n    content: none;\n  }\n  \n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n\n  * {\n    box-sizing: border-box;\n  }\n\n  img {\n    display: block;\n  \twidth: 100%;\n  \theight: auto;\n  }\n']);
	
	var _styledComponents = __webpack_require__(15);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	(0, _styledComponents.injectGlobal)(_templateObject);

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var theme = {
	  colors: {
	    base: '#121212', // Black
	    secondary: '#f1f1f1', // Light Gray
	    highlight: '#5b8bf7' // Light Blue
	  },
	  sizes: {
	    maxWidth: '1200px',
	    maxWidthCentered: '650px'
	  },
	  responsive: {
	    small: '35em',
	    medium: '50em',
	    large: '70em'
	  }
	};
	
	exports.default = theme;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-5197a6635cb9e19fb89f.js